// extracted by mini-css-extract-plugin
export default {"viewK1Link":"ViewK1ActionCell_viewK1Link__mNot3","viewK1Arrow":"ViewK1ActionCell_viewK1Arrow__Ig0RG"};